export const RedSuccess = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='64'
      height='64'
      viewBox='0 0 64 64'
      fill='none'
    >
      <path
        d='M31.9999 5.33325C17.3066 5.33325 5.33325 17.3066 5.33325 31.9999C5.33325 46.6933 17.3066 58.6666 31.9999 58.6666C46.6933 58.6666 58.6666 46.6933 58.6666 31.9999C58.6666 17.3066 46.6933 5.33325 31.9999 5.33325ZM44.7466 25.8666L29.6266 40.9866C29.2533 41.3599 28.7466 41.5733 28.2133 41.5733C27.6799 41.5733 27.1733 41.3599 26.7999 40.9866L19.2533 33.4399C18.4799 32.6666 18.4799 31.3866 19.2533 30.6133C20.0266 29.8399 21.3066 29.8399 22.0799 30.6133L28.2133 36.7466L41.9199 23.0399C42.6933 22.2666 43.9733 22.2666 44.7466 23.0399C45.5199 23.8133 45.5199 25.0666 44.7466 25.8666Z'
        fill='#FF0037'
      />
    </svg>
  );
};
